function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L36 0 36 36 0 36z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFE",
  d: "M29.145 19.47c.06-.48.105-.96.105-1.47s-.045-.99-.105-1.47l3.165-2.475c.285-.225.36-.63.18-.96l-3-5.19c-.18-.33-.585-.45-.915-.33l-3.735 1.5c-.78-.6-1.62-1.095-2.535-1.47l-.57-3.975C21.69 3.27 21.375 3 21 3h-6c-.375 0-.69.27-.735.63l-.57 3.975c-.915.375-1.755.885-2.535 1.47l-3.735-1.5c-.345-.135-.735 0-.915.33l-3 5.19c-.195.33-.105.735.18.96l3.165 2.475c-.06.48-.105.975-.105 1.47s.045.99.105 1.47L3.69 21.945c-.285.225-.36.63-.18.96l3 5.19c.18.33.585.45.915.33l3.735-1.5c.78.6 1.62 1.095 2.535 1.47l.57 3.975c.045.36.36.63.735.63h6c.375 0 .69-.27.735-.63l.57-3.975c.915-.375 1.755-.885 2.535-1.47l3.735 1.5c.345.135.735 0 .915-.33l3-5.19c.18-.33.105-.735-.18-.96l-3.165-2.475zM18 23.25c-2.895 0-5.25-2.355-5.25-5.25s2.355-5.25 5.25-5.25 5.25 2.355 5.25 5.25-2.355 5.25-5.25 5.25z"
}));

const SvgSettings = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSettings, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/settings.afb5443a.svg";
export { ForwardRef as ReactComponent };